
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useState } from 'react';

export default function NosotrosPage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentValueSlide, setCurrentValueSlide] = useState(0);
  const [currentDesignerSlide, setCurrentDesignerSlide] = useState(1);
  const [showMoreAwards, setShowMoreAwards] = useState(false);

  const heroSlides = [
    {
      image: "/images/nosotros/bano-elegante-nosotros.webp",
      alt: "navamuel-bano-elegante"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  return (
    <div className="min-h-screen" style={{ fontFamily: 'Playfair Display, serif' }}>
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center transition-all duration-1000"
          style={{ 
            backgroundImage: `url(${heroSlides[currentSlide].image})`,
            filter: 'brightness(0.7)'
          }}
        />
        <div className="absolute inset-0 bg-[#191a19]/30" />
        
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-5xl md:text-7xl font-light mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            <span className="block">Treinta años creando</span>
            <span className="block italic font-normal">experiencias</span>
            <span className="block">excepcionales</span>
          </h1>
        </div>
      </section>

      {/* DNA Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl md:text-5xl font-light mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
                  <span className="block">Nuestra</span>
                  <span className="block">esencia</span>
                </h2>
              </div>
              <div>
                <p className="text-lg text-gray-700 leading-relaxed mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                  Somos una empresa especializada en la fabricación y comercialización de muebles de baño. 30 años de experiencia, a la cabeza de la vanguardia del sector, avalan nuestra trayectoria profesional.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                  Ofrecemos una constante renovación, incorporando nuevos materiales y diseños innovadores, revolucionando el concepto del mobiliario de baño elaborado en madera. Ofrecer la mejor calidad se convierte en nuestra premisa.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Slider Section */}
      <section className="relative h-screen overflow-hidden">
        <div className="relative w-full h-full">
          {heroSlides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={slide.image}
                alt={slide.alt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </section>

      {/* Global Reach Section */}
      <section className="py-20 bg-white text-center">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-light mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="block">Garantía de calidad</span>
            </h2>
            <p className="text-xl text-gray-600 mb-8" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              NAVAMUEL, garantiza que sus productos son elaborados mediante procesos que cumplen las normas mas exigentes de calidad. La calidad no es sólo acogerse a las reglas, estas pautas deben cumplirse y arrojar unos resultados adecuados a las exigencias.
            </p>
          </div>
        </div>
      </section>

      {/* Full Screen Image */}
      <section className="h-screen overflow-hidden">
        <img
          src="/images/nosotros/bano-elegante-nosotros02.webp"
          alt="Muebles de baño elegantes y de calidad Navamuel"
          className="w-full h-full object-cover"
        />
      </section>

      <Footer />
    </div>
  );
}
